import { ReactNode } from "react";
import './CommonCard.scss';

const CommonCard = ({children}: {children?: ReactNode}) => {
  return (
    <div className="common_card">
        {children}
    </div>
  )
}

export default CommonCard